String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

class LoadingState {
    // Loading state object

    constructor(opts) {
        this.ok = false;
        this.loading = false;
        this.error = false;
        this.message = undefined;
        Object.entries(opts).forEach(([key, value]) => {
            this[key] = value;
        })
    }

    clearAll() {
        this.ok = false;
        this.loading = false;
        this.error = false;
        this.message = undefined;
    }

    setMessage(message) {
        this.message = message;
    }

    setOk(message) {
        this.clearAll();
        this.ok = true;
        this.setMessage(message);
    }

    setLoading(message) {
        this.clearAll();
        this.loading = true;
        this.setMessage(message);
    }

    setError(message) {
        this.clearAll();
        this.error = true;
        this.setMessage(message);
    }

    /**
     * Get default mutations for loading state.
     *
     * Generated mutations:
     *   - setLoadingStateOk
     *   - setLoadingStateError
     *   - setLoadingStateLoading.
     *
     * "LoadingState" part of the name can be modified by "name" input parameter.
     * Example with name "state" mutation will looks like setStateOk, setStateError, setStateLoading.
     */
    static getMutations(name = 'loadingState') {
        const mutationName = name.capitalize();
        return {
            [`set${mutationName}Ok`]: (state) => { state[name].setOk(); },
            [`set${mutationName}Loading`]: (state) => { state[name].setLoading(); },
            [`set${mutationName}Error`]: (state, message) => { state[name].setError(message); },
        }
    }

}

export default LoadingState;
